// Big achievement modal — "Level up!", "Perfect day!", etc.

import { fireConfetti } from './confetti.js';
import { playLevelUp } from './sounds.js';

export function showAchievement({ icon = '🏆', title = '¡LOGRO!', desc = '', duration = 3500, confetti = true, sound = true } = {}) {
  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.innerHTML = `
    <div class="modal-box achievement-modal">
      <div class="achievement-icon">${icon}</div>
      <div class="achievement-title">${title}</div>
      <div class="achievement-desc">${desc}</div>
      <button class="btn btn-ghost" style="background:rgba(255,255,255,.2);color:#fff;">¡SIGUE ASÍ!</button>
    </div>
  `;
  document.body.appendChild(overlay);

  if (confetti) fireConfetti();
  if (sound) playLevelUp();

  const close = () => overlay.remove();
  overlay.querySelector('button').addEventListener('click', close);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });

  if (duration > 0) setTimeout(close, duration);
}

if (typeof window !== 'undefined') window.showAchievement = showAchievement;
